import { render } from "./PopUpTrap.vue?vue&type=template&id=e904e620&scoped=true"
import script from "./PopUpTrap.vue?vue&type=script&lang=js"
export * from "./PopUpTrap.vue?vue&type=script&lang=js"

import "./PopUpTrap.vue?vue&type=style&index=0&id=e904e620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e904e620"]])

export default __exports__